import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { AttributionLink } from "@/components/AttributionLink";
import { dailyDevo } from "@/data/brand";
import { resourceLinks } from "@/data/resources";

export const ResourcesPage = () => (
  <main className="devotional-shell min-h-screen px-4 py-10 sm:px-6 lg:px-8" data-testid="resources-page">
    <div className="mx-auto max-w-5xl space-y-8">
      <nav className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between" data-testid="resources-public-nav">
        <Link to="/" className="flex items-center gap-3" data-testid="resources-brand-home-link">
          <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-full bg-white shadow-[0_6px_18px_rgba(26,54,38,0.12)]" data-testid="resources-brand-logo-wrap">
            <img src={dailyDevo.logoUrl} alt="DailyDevo logo" className="h-full w-full object-cover" data-testid="resources-brand-logo" />
          </span>
          <span>
            <span className="block font-serif-display text-2xl font-semibold text-[#1A3626]" data-testid="resources-brand-title">Fruitful</span>
            <span className="block text-xs uppercase tracking-[0.2em] text-[#8C9B90]" data-testid="resources-brand-subtitle">dailydevo.ca resources</span>
          </span>
        </Link>
        <Link to="/" className="rounded-full bg-[#1A3626] px-5 py-2 text-sm font-medium text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#4A5D4E]" data-testid="resources-open-app-link">
          Open reflection app
        </Link>
      </nav>

      <section className="gentle-reveal" data-testid="resources-header-section">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8C9B90]" data-testid="resources-overline">Additional resources</p>
        <h1 className="mt-3 font-serif-display text-4xl font-semibold text-[#1A3626] sm:text-5xl lg:text-6xl" data-testid="resources-heading">Grow with DailyDevo</h1>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#4A5D4E]" data-testid="resources-copy">Use this page to share DailyDevo links for devotionals, guides, and next steps. New links can be added in the app’s resources list.</p>
      </section>

      <section className="grid gap-4 sm:grid-cols-2" data-testid="resources-link-grid">
        {resourceLinks.map((resource) => (
          <a
            key={resource.url}
            href={resource.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group rounded-2xl border border-[#E5E1D8] bg-white p-6 shadow-[0_8px_30px_rgba(26,54,38,0.04)] transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-[#C87961]"
            data-testid={`resource-link-${resource.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <h2 className="font-serif-display text-3xl font-semibold text-[#1A3626]" data-testid={`resource-title-${resource.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{resource.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-[#4A5D4E]" data-testid={`resource-description-${resource.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{resource.description}</p>
              </div>
              <ExternalLink className="text-[#C87961] transition-transform duration-300 group-hover:translate-x-1" size={20} />
            </div>
          </a>
        ))}
      </section>

      <AttributionLink className="pt-4" />
    </div>
  </main>
);